export default {"src":"/_next/static/media/shipping6.0dc476cf.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};